<template>
  <div class="enrolling-statistics-enroll-other">
    <StatisticsCommon :title="name" :export-data="exportData">
      <div class="main-container">
        <div class="site-select">
          <CheckAllSelect v-model="siteIds" filterable multiple labelKey="name" valueKey="id" :optionList="siteList" collapse-tags>
          </CheckAllSelect>
          <i class="iconfont icon-histogram chart-type theme-text-active" :class="{active: chartType === 'bar'}" title="柱图" @click="changeChartType('bar')"></i>
          <i class="iconfont icon-pie-chart chart-type theme-text-active" :class="{active: chartType === 'pie'}" title="饼图" @click="changeChartType('pie')"></i>
        </div>
        <div class="graph-wrap" v-if="chartType === 'bar'">
          <EChartContainer ref="chart"></EChartContainer>
        </div>
        <div class="pie-graph-wrap" v-else-if="chartType === 'pie'">
          <div class="pie-graph" v-for="item in siteIds" :key="item">
            <EChartContainer :ref="'pieChart-' + item"></EChartContainer>
          </div>
        </div>
      </div>
    </StatisticsCommon>
  </div>
</template>

<script>
import StatisticsCommon from '../../common/card'
import CheckAllSelect from '../../common/checkAllSelect'
import EChartContainer from '../../../../../../../elements/EChartContainer'
export default {
  name: 'EnrollingStatisticsEnrollOther',
  components: {
    StatisticsCommon,
    EChartContainer,
    CheckAllSelect
  },
  props: {
    name: String,
    type: String,
    siteList: Array,
    batchId: {
      required: false,
      type: String
    }
  },
  data () {
    return {
      siteIds: [],
      chartType: 'bar',
      barSeriesOption: {
        type: 'bar',
        stack: 'gender',
        label: {
          show: true,
          position: 'inside',
          formatter: function (params) {
            let html = ''
            let value = params.value && params.value[params.seriesIndex + 1]
            if (value) {
              html = value + '/' + Math.round(value / params.value[params.value.length - 1] * 1000) / 10 + '%'
            }
            return html
          }
        }
      },
      barChartOption: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let html = ''
            if (params && params.length) {
              let name = params[0].name
              html += name + '<br/>'
              params.forEach(param => {
                let value = param.value && param.value[param.seriesIndex + 1]
                if (value) {
                  html += param.marker + ' ' + param.seriesName + ': ' + value + ' / ' + Math.round(value / param.value[param.value.length - 1] * 1000) / 10 + '%' + '<br/>'
                }
              })
            }
            return html
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'left'
        },
        dataset: {
          source: []
        },
        xAxis: {
          type: 'category',
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {},
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'none'
          },
          {
            type: 'inside',
            xAxisIndex: 0,
            filterMode: 'none'
          }
        ],
        series: {
        }
      },
      pieChartOption: {
        title: {
          text: '',
          left: 'center',
          textStyle: {
            color: '#999',
            fontWeight: 'normal',
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.name + ': ' + params.value[1] + ' / ' + params.percent + '%'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'left'
        },
        dataset: {
          source: []
        },
        series: [{
          type: 'pie',
          radius: '50%',
          label: {
            position: 'outside',
            formatter: function (params) {
              return params.name + ': ' + params.value[1] + ' / ' + params.percent + '%'
            }
          },
          seriesLayoutBy: 'row',
          encode: {
            itemName: '',
            value: ''
          }
        }]
      },
      data: []
    }
  },
  methods: {
    loadData () {
      if (this.batchId && this.siteIds && this.siteIds.length) {
        this.$ajax({
          url: `/workspace/manager/enrolling/statistics/queryEnrollData/${this.type}`,
          method: 'post',
          data: this.$qs.stringify({
            batchId: this.batchId,
            siteIds: this.siteIds
          }, {arrayFormat: 'repeat'})
        }).then((response) => {
          if (response['data']) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.data = response.data['data'] || []
                this.handleChart()
                break
              }
            }
          }
        })
      }
    },
    handleChart () {
      if (this.batchId && this.siteIds && this.siteIds.length) {
        if (this.chartType === 'bar') {
          this.barChartOption.dataset.source = this.data
          let series = []
          for (let i = 1; i < this.barChartOption.dataset.source[0].length - 1; i++) {
            series.push(this.barSeriesOption)
          }
          this.barChartOption.series = series
          this.initChart(this.$refs.chart, this.barChartOption)
        } else if (this.chartType === 'pie') {
          for (let i = 1; i < this.data.length; i++) {
            let dataSet = []
            dataSet.push(this.data[0].slice(0, this.data[0].length - 1))
            dataSet.push(this.data[i].slice(0, this.data[0].length - 1))
            this.pieChartOption.dataset.source = dataSet
            this.pieChartOption.series[0].encode = {itemName: dataSet[0][0], value: dataSet[1][0]}
            this.pieChartOption.title.text = dataSet[1][0]
            this.initChart(this.$refs['pieChart-' + this.siteIds[i - 1]][0], this.pieChartOption)
          }
        }
      }
    },
    changeChartType (chartType) {
      this.chartType = chartType
      this.$nextTick(() => this.handleChart())
    },
    initChart (chart, chartOption) {
      if (chart) {
        chart.clear()
        chart.setOption(chartOption)
      }
    },
    exportData () {
      if (this.batchId && this.siteIds && this.siteIds.length) {
        this.$ajax({
          url: `/workspace/manager/enrolling/statistics/exportEnrollData/${this.type}`,
          method: 'post',
          data: this.$qs.stringify({
            batchId: this.batchId,
            siteIds: this.siteIds
          }, {arrayFormat: 'repeat'})
        }).then((response) => {
          if (response['data']) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                window.location.href = response.data['fileUrl']
                break
              }
              default: {
                this.$message.error('导出失败')
              }
            }
          }
        })
      }
    }
  },
  watch: {
    siteIds: function () {
      this.loadData()
    },
    batchId: function () {
      this.loadData()
    },
    siteList: function (val) {
      if (!this.siteIds || this.siteIds.length === 0) {
        this.siteIds = val.map(site => site.id).slice(0, 1)
      }
    }
  },
  mounted () {
    // this.loadData()
  }
}
</script>

<style lang="scss">
.enrolling-statistics-enroll-other {
  width: 100%;
  padding: 10px 20px;
  border-bottom: solid 1px #EBEEF5;
  .main-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .site-select {
      padding-bottom: 10px;
      .chart-type {
        margin-left: 15px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    .graph-wrap {
      width: 100%;
      height: 500px;
      .e-chart-container {
        height: 100%;
      }
    }
    .pie-graph-wrap {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .pie-graph {
        width: 50%;
        height: 300px;
        .e-chart-container {
          height: 100%;
        }
      }
    }
  }
}
</style>
